module.exports = "https://static.wmbcdn.com/uniweb/images/c393c7306313d00a7838a3c045105e5d.svg";